import React from 'react';
import './home.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import InstagramPosts from './instagramposts';
import { Link} from 'react-router-dom'; 

const Home = () => {
    // Exemplu de date (în mod real ar trebui să fie obținute dintr-o sursă externă)
    const posts = [
      {
        imageUrl: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918878/post4_cee4jt.jpg',
        description: "Purtată de o stare...",
        likes: 244,
        comments: 39,
        link: "https://www.instagram.com/p/DKGpDmcIOR8/",
      },
      {
        imageUrl: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918874/post2_lr4i9f.jpg',
        description: "Parcul ăsta este...",
        likes: 255,
        comments: 42,
        link: "https://www.instagram.com/p/DH0isdSoyyl/",
      },

      {
        imageUrl: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918883/post1_iornty.jpg',
        description: "Așa a arătat părul meu...",
        likes: 261,
        comments: 55,
        link: "https://www.instagram.com/p/DHGUtFgo7Nq/",
      },
      {
        imageUrl: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918884/post7_wcxmie.jpg',
        description: "A trecut mult timp de...",
        likes: 226,
        comments: 45,
        link: "https://www.instagram.com/p/DJbwtqTIyT_/",
      },
      {
        imageUrl: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918874/post6_owccof.jpg',
        description: "Anul ăsta am ajuns...",
        likes: 332,
        comments: 40,
        link: "https://www.instagram.com/p/DEFK0Q-IDLr/",
      },
      {
        imageUrl: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918876/post5_mrppys.jpg',
        description: "a dream come true 🫠🏔️",
        likes: 267,
        comments: 39,
        link: "https://www.instagram.com/p/C8eM7hes4aU/",
      },
      {
        imageUrl: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918872/post3_lxtxhe.jpg',
        description: "Lumina din cabina...",
        likes: 222,
        comments: 58,
        link: "https://www.instagram.com/p/DGFX6DdIFSq/",
      },
      {
        imageUrl: 'https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918873/post8_vrl78y.jpg',
        description: "Ce părere aveți de țin...",
        likes: 302,
        comments: 42,
        link: "https://www.instagram.com/p/DHBhdEcIQXI/",
      },
    ];


    return (  
        <div className='containter'>
            {/* ******* IMAGE ******* */}
            <img src='https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918889/banner_hv7u81.jpg' alt="main page pic" className='homeImage'/>
            {/* ******* PREVIEW MENU ******* */}
            <div className='row homePreview'>
                <div className='homePreviewObject col-2 col-md-2 col-lg-1'>
                  <Link to="/about">
                    <img src='https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918887/aboutme_cd9ycd.png' alt="preview thumbnails" className='circleImg img-fluid' />
                  </Link>
                  <span className='homePreviewTitles'>About</span>
                </div>
                <div className='homePreviewObject col-2 col-md-2 col-lg-1'>
                  <a href='./presetsnluts'><img src='https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918874/presetsnLuts_bdvlld.png'alt="preview tumbnails" className='circleImg img-fluid'/></a>
                  <span className='homePreviewTitles'>Presets</span>
                </div>
                <div className='homePreviewObject col-2 col-md-2 col-lg-1'>
                  <a href='/travel'><img src='https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918878/travel_ixo3nc.png' alt="preview tumbnails" className='circleImg img-fluid'/></a>
                  <span className='homePreviewTitles'>Travel</span>
                </div>
                <div className='homePreviewObject col-2 col-md-2 col-lg-1'>
                  <a href='/portfolio'><img src='https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918872/portfolio_too5i0.png' alt="preview tumbnails" className='circleImg img-fluid'/></a>
                  <span className='homePreviewTitles'>Portfolio</span>
                </div>
                <div className='homePreviewObject col-2 col-md-2 col-lg-1'>
                  <a href='/contact'><img src='https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918886/contact_dg22jx.png' alt="preview tumbnails" className='circleImg img-fluid'/></a>
                  <span className='homePreviewTitles'>Contact</span>
                </div>
                
            </div> {/* row*/}
            
            <div className="row homePnL">
                <div className='homePnLText col-7 col-md-5 col-lg-5'>
                <span>I've made Presets & LUTs</span>
                <span className="homePnLSubtitle">See all of them here:</span>
                </div>
                <img src='https://res.cloudinary.com/dj9fifhwt/image/upload/v1748918881/iconLutInstall_udvdyv.png' alt="preview tumbnails" className='homePNLIMG img-fluid col-sm-5 col-md-5 col-lg-5'/>
            </div>
             {/* ******* IG PART ******* */}
             <div className="homeGradient">
                <span className='homeIgTitle'>See me on Instagram</span>
                <span className="homeIgSubtitle">Click on any picture to see the original post.</span>
                <div className="instagram-posts">
                    {posts.map((post, index) => (
                    <InstagramPosts
                        key={index}
                        imageUrl={post.imageUrl}
                        description={post.description}
                        likes={post.likes}
                        comments={post.comments}
                        link={post.link}
                    />
                    ))}
                </div>
            </div>
            <div>

              
            </div>
            
            </div> 
      );
    }

export default Home;